"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitePlanInformation = void 0;
var React = require("react");
var SiteInfoService_1 = require("../../services/SiteInfoService");
var CurrentSelection_1 = require("../../services/CurrentSelection");
var EditSiteInfo_1 = require("../admin/site_maps/EditSiteInfo");
var EditMapLocations_1 = require("../admin/site_maps/EditMapLocations");
var SiteMapService_1 = require("../../services/SiteMapService");
var utils_1 = require("../../utils");
var MapLayout_1 = require("../admin/site_maps/map_layout/MapLayout");
var BookingLocationService_1 = require("../../services/BookingLocationService");
var stateless_forms_1 = require("./forms/stateless_forms");
var SiteMapLayerService_1 = require("../../services/SiteMapLayerService");
var SitePlanInformation = function (_a) {
    var project_id = _a.project_id;
    var containerRef = React.useRef();
    var _b = __read((0, SiteInfoService_1.useSiteInfoService)(project_id), 2), site_info = _b[0], siteInfoService = _b[1];
    var site_id = site_info === null || site_info === void 0 ? void 0 : site_info.id;
    var _c = __read((0, SiteMapService_1.useSiteMapService)(project_id), 2), map_info = _c[0], siteMapSvc = _c[1];
    var _d = __read((0, SiteMapLayerService_1.useSiteMapLayerService)(project_id), 2), layer_data = _d[0], siteLayerSvc = _d[1];
    var current_map = (0, utils_1.get_first)(map_info);
    var _e = __read((0, BookingLocationService_1.useBookingLocationService)(project_id), 2), site_location_info = _e[0], siteLocationService = _e[1];
    var _f = __read((0, CurrentSelection_1.useCurrentSelection)(undefined, site_location_info), 2), getCurrentLocation = _f[0], setCurrentLocation = _f[1];
    var current_location = getCurrentLocation();
    React.useEffect(function () {
        siteInfoService.list();
        siteMapSvc.list();
        siteLayerSvc.list();
        siteLocationService.list();
    }, [project_id]);
    return (React.createElement("div", { className: "container-fluid" }, current_map && (React.createElement("div", { className: "row mt-2 mb-2", style: { height: "calc(100% - 1rem)" } },
        React.createElement("div", { className: "col-9", style: { height: "100%" }, ref: containerRef },
            React.createElement(MapLayout_1.MapLayout, { current_map: current_map, site_map_location_info: site_location_info, siteLocationSvc: siteLocationService, setCurrentLocation: setCurrentLocation, allow_marker_drag: true, formatter: function (location) {
                    return {
                        icon_color: location.status == BookingLocationService_1.LocationStatus.OPEN
                            ? "#599257"
                            : "#a8051b",
                        icon_type: SiteMapLayerService_1.default_layer_icon,
                        font_size: 2,
                        icon_size: 1.25,
                    };
                } })),
        React.createElement("div", { className: "col-3" },
            React.createElement(EditSiteInfo_1.EditSiteInfo, { site_info: site_info, siteInfoSvc: siteInfoService, map_id: current_map.id, siteMapSvc: siteMapSvc, allow_add: false }),
            React.createElement(EditMapLocations_1.EditMapLocations, { site_id: site_id, map_id: current_map.id, layer_data: layer_data, allow_layer: false, location: current_location, changeLocation: setCurrentLocation, siteLocationService: siteLocationService, custom_fields: [
                    {
                        name: "status",
                        label: gettext("Status"),
                        field_type: stateless_forms_1.SimpleFormFieldTypes.SELECT,
                        options: BookingLocationService_1.location_status_options,
                        value: function (values) {
                            return (values === null || values === void 0 ? void 0 : values.status) || BookingLocationService_1.LocationStatus.OPEN;
                        },
                        required: true,
                    },
                ] }))))));
};
exports.SitePlanInformation = SitePlanInformation;
